import React, { Component, useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import AccountMobile from "./accountMobile";
import AccountWeb from "./accountWeb";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";

const AccountComponent = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Account",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <AccountWeb></AccountWeb>
      </BrowserView>
      <MobileView>
        <AccountMobile></AccountMobile>
      </MobileView>
    </>
  );
};

export default AccountComponent;
